import React from 'react';
import AsyncPartnerFinance from './async';
import SingleColumnLayout from '../../../components/layout/SingleColumnLayout';
import {Trans} from 'react-i18next';

const parent = {
  title: <Trans i18nKey="p.p.partner.title">Online Service Partner</Trans>,
  path: '/partner',
};
export default [
  <SingleColumnLayout
    exact
    key="partner-finance"
    path="/partner/finance"
    component={AsyncPartnerFinance}
    title={<Trans i18nKey="p.p.finance.title">Finance</Trans>}
    parents={[parent]}
  />,
];
